import { ComponentPropsWithoutRef } from 'react';
import cn from 'classnames';

type Props = ComponentPropsWithoutRef<'div'>;

const TooltipBox = ({ children, ...props }: Props) => {
  return (
    <div {...props} className={cn('box_tooltip', props.className)}>
      {children}
    </div>
  );
};

export default TooltipBox;
